module.exports = __webpack_public_path__ + "static/media/Stephanie Spalding Headshot_1707731153171.ffe19ae3.jpeg";